import { CancelTokenSource } from 'axios';
import axios from 'services/http';
import { MandateBillDto } from 'ts-types/api.types';

const {REACT_APP_API_BASE_URL: baseUrl} = process.env;
const apiUri = `${baseUrl}/api/mandate-bills`;

export const getDefaultBills = (source: CancelTokenSource): Promise<Array<MandateBillDto>> => {
  return axios
      .get(`${apiUri}/default-bills`, {cancelToken: source.token})
      .then(response => response.data);
};


export const getAllMandateBillsByMandateId = (mandateId: number, source: CancelTokenSource) => {
  return axios.
      get(`${apiUri}/${mandateId}`, { cancelToken: source.token })
      .then(response => response.data);
};
